<template>
    <button class="default-button"
            :class="variationClasses"
            :disabled="disabled"
            ref="button"
            @mousedown="startRipple"
            @mouseup="endRipple"
            @mouseleave="cancelRipple"
            @touchstart="startRipple"
            @touchend="endRipple"
            @click.prevent="clickHandler"
    >
        <span class="default-button__ripple-container"
              ref="rippleContainer"
        />

        <span class="default-button__text">
            <slot />
        </span>
    </button>
</template>

<script>
import { ClickRippleMixin } from './mixins/click-ripple';
import { DisabledMixin } from './mixins/disabled';

export default {
    name: 'DefaultButton',
    mixins: [ DisabledMixin, ClickRippleMixin ],
    props: {
        variations: {
            type: Array,
            default: () => []
        }
    },
    computed: {
        variationClasses() {
            return this.variations.join(' ');
        }
    },
    mounted() {
        this.rippleConfig.container = this.$refs.rippleContainer;
    },
    methods: {
        clickHandler(event) {
            this.$emit('click', event);
        }
    }
}
</script>

<style scoped lang="scss">
    .default-button {
        position: relative;
        display: inline-block;
        border: 0;
        outline: 0;
        cursor: pointer;
        border-radius: 0.125rem;
        padding-top: 0.75rem;
        padding-left: 1rem;
        padding-right: 1rem;
        padding-bottom: 0.75rem;
        background-color: $color-action;
        transition: background-color ease-out .2s, color ease-out .2s;
        width: auto;

        &:hover {
            background-color: darken($color-action, 2);
        }

        &.full-width {
            width: 100%;
        }

        &.danger {
            background-color: $color-danger;

            &:hover {
                background-color: darken($color-danger, 2);
            }
        }

        &.icon {
            padding-top: 0.5rem;
            padding-bottom: 0.5rem;
        }

        &[disabled] {
            cursor: default;
            background-color: $color-disabled;
        }
    }

    .default-button__ripple-container {
        position: absolute;
        display: block;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        z-index: 0;
    }

    .default-button__text {
        font-size: 1rem;
        color: $color-action-contrast;
        line-height: 1;
        vertical-align: middle;

        .default-button[disabled] & {
            color: $color-disabled-contrast;
        }

        .icon & {
            @include icon-font;
            font-size: 2rem;
        }
    }
</style>
